import { GolfAvatar } from '@/components/ui/GolfAvatar';
import { getAnimatedVideoThumbnailUrl } from '@/lib/utils';
import { IonRouterLink } from '@ionic/react';
// Like functionality is now handled by the LikeButton component
import React, { useState } from 'react';
import OpenedPost from './OpenedPost';
import { ImageWithFallback } from './ui/fallbackImage';
// Using LikeButton component instead of direct GolfIcon
import LikeButton from './ui/LikeButton';

interface PostLightProps {
  id: number;
  user: {
    id: number;
    firstName: string;
    lastName: string;
    imageUrl: string;
    username: string;
  };
  media: { type: 'image' | 'video' | 'gif'; url: string }[];
  likes: number;
  isLiked: boolean;
  course: {
    id: number;
    name: string;
  };
  caption: string;
  profileId: number;
  comments: number;
  audience: number;
  createdAt: string;
  onDelete: (postId: number) => void;
  className?: string;
}

export const PostLight: React.FC<PostLightProps> = ({
  id,
  user,
  media,
  likes,
  isLiked,
  course,
  caption,
  profileId,
  onDelete,
  className,
  createdAt,
  comments,
  // audience is not used in this component
}) => {
  const [showPost, setShowPost] = useState(false);
  const [likeCount, setLikeCount] = useState(likes);
  const [liked, setLiked] = useState(isLiked);

  return (
    <div className={className}>
      {/* Post Image */}
      {media.length > 0 && (
        media[0].type === 'image' ? (
          <div onClick={() => setShowPost(true)}>
            <ImageWithFallback
              alt="Post image"
              fallbackImage="/assets/images/fallback.jpg"
              src={media[0].url}
              className="w-full min-h-[248px] object-cover rounded-t-md cursor-pointer"
            />
          </div>
        ) : (
          <div onClick={() => setShowPost(true)}>
            <ImageWithFallback
              alt="Post image"
              fallbackImage="/assets/images/fallback.jpg"
              src={getAnimatedVideoThumbnailUrl(media[0].url)}
              className="w-full object-cover rounded-t-md"
            />
          </div>
        )
      )}

      <div className="mt-2 flex items-center justify-between">
        <div className="ml-2 flex items-center gap-2 text-sm">
          <IonRouterLink routerLink={`/u/${user.username}`}>
            <GolfAvatar size={28} imageUrl={user.imageUrl} />
          </IonRouterLink>
          <IonRouterLink routerLink={`/u/${user.username}`} className="text-ellipsis overflow-hidden whitespace-nowrap">
            {user.username}
          </IonRouterLink>
        </div>
        <LikeButton
          postId={id}
          initialLiked={liked}
          initialLikeCount={likeCount}
          userId={profileId?.toString() || ''}
          showCount={true}
          showLabel={false}
          size="sm"
          className="text-foreground text-sm size-10"
          onLikeChange={(newIsLiked, newCount) => {
            setLiked(newIsLiked);
            setLikeCount(newCount);
          }}
        />
      </div>

      {/* OpenedPost Modal */}
      <OpenedPost
        isOpen={showPost}
        onDidDismiss={() => setShowPost(false)}
        postId={id}
        user={user}
        media={media}
        likes={likes}
        isLiked={isLiked}
        course={course}
        caption={caption}
        comments={comments}
        profileId={profileId}
        onDelete={onDelete}
        createdAt={createdAt}
      />

    </div>
  );
};